import React, { useContext } from 'react';
import { AppContext } from '../app/AppProvider.component';
import { ActivityTypeConfigMap, } from '../../models/remediation.models';
import { FlexLayout } from '../flex/FlexLayout.component';
import { FlexItem } from '../flex/FlexItem.component';
import { FlexLayoutModifier } from '../flex/flex.constants';
import { AssessmentGoalDto } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import { RemediationActivityTypeDto } from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import {
  getContentTypeMainDisplay,
  getContentTypesFromActivityType,
  getMetricCounts,
  getProgressDisplay
} from '../../utilities/remediation.utilities';
import { ActivityProgressBar } from '../activity-progress-bar/ActivityProgressBar.component';

export type RemediationActivityProgressProps = {
  assessmentGoals: AssessmentGoalDto[];
  activityType: RemediationActivityTypeDto;
};

const RemediationActivityProgress = (props: RemediationActivityProgressProps): JSX.Element => {

  const { appState } = useContext(AppContext);
  const baseState = appState.remediationBaseState;

  const {
    activityType
  } = props;

  const metricCounts = getMetricCounts(baseState, activityType);
  const progressDisplay = getProgressDisplay(metricCounts, activityType);
  const contentTypes = getContentTypesFromActivityType(activityType, baseState);
  const contentTypesDisplay = getContentTypeMainDisplay(contentTypes, null);

  return (
    <div>
      <div>
        <FlexLayout modifiers={[
          FlexLayoutModifier.GUTTERS,
          FlexLayoutModifier.MIDDLE,
        ]}>
          <FlexItem modifiers={[FlexLayoutModifier.GROW]}>
            <strong>{ActivityTypeConfigMap[activityType].title}: {contentTypesDisplay}</strong>
          </FlexItem>
          <FlexItem>
            <span className="u-els-color-n7">{progressDisplay}</span>
          </FlexItem>
        </FlexLayout>

        <div className="o-els-container o-els-container--1o2">
          <ActivityProgressBar metricCounts={metricCounts} activityType={activityType} />
        </div>
      </div>
    </div>
  );
};
export default RemediationActivityProgress;
